module.exports = window["__sharedUseModal"];